import { Action, createReducer, on } from '@ngrx/store';

import * as OccupationCardsActions from './occupation-cards.actions';
import * as OccupationCardsState from './occupation-cards.state';

const occupationCardsReducer = createReducer(
  OccupationCardsState.initialOccupationCardsState,

  on(OccupationCardsActions.loadOccupationCards, (state) => ({
    ...state,
    loading: true
  })),

  on(
    OccupationCardsActions.loadOccupationCardsSuccess,
    (state, { occupationCategories, occupationCards }) => {
      return OccupationCardsState.occupationCardsStateAdapter.setAll(
        occupationCategories ?? [],
        { ...state, loading: false, occupationCards }
      );
    }
  ),

  on(OccupationCardsActions.loadOccupationCardsError, (state) => ({
    ...state,
    loading: false
  }))
);

export function reducer(
  state: OccupationCardsState.OccupationCardsState | undefined,
  action: Action
) {
  return occupationCardsReducer(state, action);
}
